/*
 * @Author       : aa
 * @Date         : 2020-09-10 13:26:47
 * @Description  : file content
 * @FilePath     : \vue-gaokao-ebook\src\assets\js\evaluation-type.js
 */
const evaluationType = [
  {
    "label": '全部',
    "value": null,
  },
  {
    "label": '专家测评',
    "value": 100,
  },
  {
    "label": '过关测试',
    "value": 400,
  },
  {
    "label": '实战演练',
    "value": 200,
  },
  // {
  //   "label": '高考真题',
  //   "value": 1,
  // },
  // {
  //   "label": '基础夯实',
  //   "value": 11,
  // },
  // {
  //   "label": '专题强化',
  //   "value": 21,
  // },
  // {
  //   "label": '摸底考试',
  //   "value": 4,
  // },
  // {
  //   "label": '查漏补缺',
  //   "value": 3,
  // },
  // {
  //   "label": '考前冲刺',
  //   "value": 2,
  // }

]

export default evaluationType